"use client"

import { ADMIN_API_CONFIG } from "@/constants/api-configs"
import { t } from "@/languages/i18n"
import { DefaultImage } from "@/lib/external-components"
import Image from "next/image"
import Link from "next/link"

interface FooterSocialSectionProps {
  iconList?: Array<{
    icon: string
    url: string
  }>
}

export const FooterSocialSection = ({ iconList }: FooterSocialSectionProps) => {
  if (!iconList || iconList.length === 0) {
    return null
  }

  return (
    <div className="flex flex-col gap-3">
      <h3 className="text-[#242F3E] text-sm font-semibold">{t("Follow Us On")}</h3>
      <div className="flex flex-row gap-3">
        {iconList.map((icon, index) => (
          <Link
            key={index}
            href={icon.url || "#"}
            rel="noopener noreferrer"
            target="_blank"
            className="group transition-all"
          >
            <Image
              src={icon.icon ? `${ADMIN_API_CONFIG.API_URL}${icon.icon}` : DefaultImage}
              width={20}
              height={20}
              alt="Social Icon"
              className="h-5 w-5 transition-all group-hover:brightness-0 group-hover:saturate-100"
              style={{
                filter: "none",
              }}
              onMouseEnter={e => {
                e.currentTarget.style.filter =
                  "brightness(0) saturate(100%) invert(52%) sepia(17%) saturate(1169%) hue-rotate(72deg) brightness(0.95) contrast(0.93)"
              }}
              onMouseLeave={e => {
                e.currentTarget.style.filter = "none"
              }}
            />
          </Link>
        ))}
      </div>
    </div>
  )
}
